<div id="layout" class="magic-link-login f_col">
  <app-view-title fromRoute="magic-link-login" toRoute="choose-lang" [chooseLangBtn]="api.env.supportedLanguages.length > 1">{{'magicLinkLogin.title' | translate}}</app-view-title>
  
  <div class="scroll_wrapper resp_wrapper" *ngIf="!linkSent">
    <div class="resp_scroll-wrapper_l resp_c-50">
      <app-view-deco-image imageUrl="assets/images/image_access.svg"></app-view-deco-image>
      
      <div class="input-type-selector f_center mb_20" *ngIf="showInputTypeSelector">
        <app-button 
          size="xsm" 
          [color]="inputType === 'email' ? 'primary' : 'transparent'" 
          [border]="inputType !== 'email'" 
          class="mr_10" 
          (btnClicked)="onInputTypeChange('email')">
          {{'magicLinkLogin.email' | translate}}
        </app-button>
        <app-button 
          size="xsm" 
          [color]="inputType === 'phone' ? 'primary' : 'transparent'" 
          [border]="inputType !== 'phone'" 
          (btnClicked)="onInputTypeChange('phone')">
          {{'magicLinkLogin.phone' | translate}}
        </app-button>
      </div>

      <p class="text_center mb_20" *ngIf="showInputTypeSelector">{{'magicLinkLogin.description' | translate}}</p>
      <p class="text_center mb_20" *ngIf="isEmailEnabled && !isSmsEnabled">{{'magicLinkLogin.descriptionEmailOnly' | translate}}</p>
      <p class="text_center mb_20" *ngIf="!isEmailEnabled && isSmsEnabled">{{'magicLinkLogin.descriptionSmsOnly' | translate}}</p>

      <form *ngIf="form" id="form" [formGroup]="form" (ngSubmit)="submitForm()">
        <div *ngIf="inputType === 'phone'" class="phone-input-container mb_15">
          <app-phone-country-select [formGrp]="form" formCtrlName="account"/>
        </div>
        <app-input
          *ngIf="inputType === 'email'"
          type="email" 
          formCtrlName="account" 
          [formGrp]="form" 
          label="form.email"
          icon="at">
        </app-input>
        <app-errors-list [dark]="true" *ngIf="submitted" [formErrors]="forms.getFormErrors(this.form)"></app-errors-list>
      </form>

      <div class="resp_minSize_l mt_20">
  <app-button size="sm" type="submit" formId="form" class="fullWidth mb_5" [disabled]="form.invalid">{{'magicLinkLogin.sendLink' | translate}}</app-button>
      </div>
    </div>
    
    <div class="f_align_end f_col mt_10 mb_20 resp_maxSize_l">
  <app-button type="submit" formId="form" class="fullWidth mb_5" [disabled]="form.invalid">{{'magicLinkLogin.sendLink' | translate}}</app-button>
  <app-button color="transparent" border="true" class="fullWidth" (btnClicked)="nav.to('sign-in')">{{'global.cancel' | translate}}</app-button>
    </div>
  </div>

  <!-- Success state -->
  <div class="scroll_wrapper resp_wrapper" *ngIf="linkSent">
    <div class="resp_c-50 resp_scroll-wrapper_l">
      <app-view-deco-image imageUrl="assets/images/image_mail_sent.svg"></app-view-deco-image>
      <p class="text_center mb_30">{{'magicLinkLogin.linkSent' | translate}}</p>
      <p class="text_center mb_30" *ngIf="inputType === 'email'">{{'magicLinkLogin.checkEmail' | translate}}</p>
      <p class="text_center mb_30" *ngIf="inputType === 'phone'">{{'magicLinkLogin.checkSms' | translate}}</p>
      
      <div class="resp_minSize_l mt_20">
        <app-button size="sm" color="transparent" border="true" class="fullWidth mb_5" (btnClicked)="resetForm()">{{'magicLinkLogin.sendAnother' | translate}}</app-button>
        <app-button size="sm" color="transparent" border="true" class="fullWidth" (btnClicked)="resetForm()">{{'magicLinkLogin.backToLogin' | translate}}</app-button>
      </div>
    </div>
    
    <div class="f_align_end f_col mt_10 mb_20 resp_maxSize_l">
      <app-button color="transparent" border="true" class="fullWidth mb_5" (btnClicked)="resetForm()">{{'magicLinkLogin.sendAnother' | translate}}</app-button>
      <app-button color="transparent" border="true" class="fullWidth" (btnClicked)="resetForm()">{{'magicLinkLogin.backToLogin' | translate}}</app-button>
    </div>
  </div>
</div>
